import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./styles/Collection.css";
import WebsiteFooter from "../components/WebsiteFooter";
import Card from "../components/Card";

const Category = ({ productsData, addToCart, products }) => {
    const { categoryName } = useParams(); // Get categoryName from the URL
    const [items, setItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();

    const handleCategoryNavigation = (path) => {
        const timestamp = new Date().toISOString();
        window.gtag("event", `${path}category_selected`, { 'timestamp': timestamp.toLocaleString(), "click": path })
        navigate(`/Collections/Category/${path}`);
    };

    const handleProductNavigation = (product) => {
        const timestamp = new Date().toISOString();
        window.gtag("event", `Category_${product}_viewed`, { 'timestamp': timestamp.toLocaleString(), "click": product })
        navigate(`/Product/${product}`);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!productsData || productsData.length === 0) return;

                const uniqueCategory = [];
                productsData.forEach((product) => {
                    if (!uniqueCategory.includes(product.Category)) {
                        uniqueCategory.push(product.Category);
                    }
                });

                setCategories(uniqueCategory);

                const filteredItems = productsData.filter(item => item.Category === categoryName);

                setItems(filteredItems);
            } catch (error) {
                console.error("Error fetching collection data:", error);
            }
        };

        fetchData();
    }, [categoryName, productsData]);

    return (
        <>
            <div className="collections-container">
                <h5>Shop By Category</h5>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {categories.map((category) => (
                        <span
                            key={category}
                            className={`${category === categoryName ? "Shop_By_Selected" : "Shop_By"}`}
                            onClick={() => {
                                handleCategoryNavigation(category);
                            }}
                        >
                            {category}
                        </span>
                    ))}
                </div>
                <h1>{categoryName}</h1>
                <div className="items-grid">
                    {items.length > 0 ? (
                        items.map((item, index) => (
                            <Card key={index} item={item} addToCart={addToCart} onClick={() => handleProductNavigation(item.Name)} products={products} />
                        ))
                    ) : (
                        <p>No items available for this category</p>
                    )}
                </div>
            </div>
            <WebsiteFooter />
        </>
    );
};

export default Category;
